import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces/stateExtended'


export function useAuthStatus() {
  const isAuthenticated = useSelector((state: StateExtended) => state.user.isAuthenticated)
  return isAuthenticated
}

export function useStoreSelector() {
  const store = useSelector((state: StateExtended) => state.user ? state.user.store :  null)
  return store
}

export function useStoreBrnDSSelector() {
  const branchDS = useSelector((state: StateExtended) => state.user ? state.user.branchDS :  null)
  return branchDS
}
